import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import cx from 'classnames'
import s from "./Outro.module.scss"

import BgImg from "assets/images/2024-ui/background-1.jpg";
import Ribbon from "assets/images/2024-ui/red-ribbon.png";
import useQuery from "hooks/useQuery";

import BackgroundCorners from "components/BackgroundCorners";

Outro.defaultProps = {}
const SLIDES = {
  yeti: [
    {
      img: require("assets/images/2024-ui/outro-img-yeti-1.png").default,
      copy: {
        en: require("assets/images/en/outro/outro-copy-1.png").default,
        es: require("assets/images/es/outro/outro-copy-1.png").default,
      },
      copyAltText: {
        en: "You made it! Now let's find deals on the best gifts. ",
        es: "¡Lo lograste! Ahora encontremos ofertas en los mejores regalos.",
      },
    },
  ],
  bear: [
    {
      img: require("assets/images/2024-ui/outro-img-bear-1.png").default,
      copy: {
        en: require("assets/images/en/outro/outro-copy-1.png").default,
        es: require("assets/images/es/outro/outro-copy-1.png").default,
      },
      copyAltText: {
        en: "You made it! Now let's find deals on the best gifts. ",
        es: "¡Lo lograste! Ahora encontremos ofertas en los mejores regalos.",
      },
    },
  ],
  seal: [
    {
      img: require("assets/images/2024-ui/outro-img-seal-1.png").default,
      copy: {
        en: require("assets/images/en/outro/outro-copy-1.png").default,
        es: require("assets/images/es/outro/outro-copy-1.png").default,
      },
      copyAltText: {
        en: "You made it! Now let's find deals on the best gifts. ",
        es: "¡Lo lograste! Ahora encontremos ofertas en los mejores regalos.",
      },
    },
  ],
}

const translate = {
  skip: {
    en: "Skip",
    es: "Saltar",
  },
}

export default function Outro({ onComplete }) {
  const lang = useQuery().get("lang") || "en";
  const { character } = useSelector((state) => state.game)
  const [killMe,setKillMe] = useState(null);
  const [slide, setSlide] = useState(0)

  useEffect(() => {
    if (slide <= SLIDES[character].length) {
      setKillMe(setTimeout(() => {
        if (slide < SLIDES[character].length - 1) {
          setSlide(slide + 1);
        } else {
          // onComplete();
          killIt();
        }
      }, 6000));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slide]);

  const killIt = () => {
    clearTimeout(killMe);
    onComplete();
  }

  const getSlides = (index) => {
    return (
      <>
        <div className={s.imageWrapper}>
          {SLIDES[character].map((characterSlide, i) => (
            <img
              src={characterSlide.img}
              alt=""
              className={cx(s.story, { [s.active]: i === index })}
              key={`slide-img-${i}`}
            />
          ))}
        </div>
        <div className={s.textWrapper}>
          <img src={Ribbon} alt="" className={cx(s.ribbon, s.active)} />
          {SLIDES[character].map((characterSlide, i) => (
            <img
              src={characterSlide.copy[lang]}
              alt={characterSlide.copyAltText[lang]}
              className={cx(s.story, { [s.active]: i === index })}
              key={`copy-img-${i}`}
            />
          ))}
        </div>
      </>
    );
  }

  return (
    <div className={s.Outro}>
      <div className={s.background}>
        <img src={BgImg} alt="" className={s.bg} />
        <BackgroundCorners className={s.corners} />
      </div>
      <div className={s.content}>
        {getSlides(slide)}
        <button className={cx(s.skip, 'link')} onClick={onComplete}>
          {translate.skip[lang]}
        </button>
      </div>
    </div>
  )
}
